export default __webpack_public_path__ + "static/media/26.ceb907db.pdf";